"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import NetworkServicesTabs from "@/components/pageTabs/networkServicesTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import ServiceByOneMind from "./components/serviceByOneMind";
import Solutions from "./components/solutions";

const NocSocHelpdeskPage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <NetworkServicesTabs />
      <Intro />
      <ServiceByOneMind />
      <Solutions />
      <Faqs />
    </PageLayout>
  );
};

export default NocSocHelpdeskPage;
